import { FC, useMemo } from "react"
import { IToothIPRData } from "./index"
import Polyline from "./Polyline"
import "./scss/MyUpPolyline.scss"

interface IProps {
  toothIPRData: IToothIPRData
}
const MyUpPolyline: FC<IProps> = ({ toothIPRData }) => {
  const pl = 24
  const itemWidth = 42
  const width = 878 //830
  const { iprURToothDataMemo, iprULToothDataMemo } = toothIPRData
  const toothPos = [
    50, 102, 162, 215, 275, 325, 377, 437, 495, 545, 602, 660, 710, 775, 810,
    862,
  ]
  const getUpList = useMemo(() => {
    const upList = [...iprURToothDataMemo, ...iprULToothDataMemo]

    const hasNonMissingToothAfter = (currentIndex: number): boolean => {
      for (let i = currentIndex + 1; i < upList.length; i++) {
        if (!upList[i].isMissingTooth) {
          return true
        }
      }
      return false
    }

    let findIndexs = upList
      .map((item, index) => {
        const indices: (number | undefined)[] = []
        if (index === upList.length - 1) {
          indices.push(index)
        }

        if (item.isMissingTooth) {
          indices.push(index)
          if (index === upList.length - 1) indices.push(index - 1)
        }

        if (!hasNonMissingToothAfter(index)) {
          indices.push(index)
        }
        return indices
      })
      .flat()
      .filter((item): item is number => item !== undefined)
      .filter((item, index, arr) => arr.indexOf(item) === index)
      .sort((a, b) => a - b)

    const isNotMissingData = upList.filter((item, index) => {
      return !findIndexs.includes(index)
    })

    const toothPosMap = toothPos.filter(
      (item, index) => !findIndexs.includes(index),
    )
    const posData = isNotMissingData.map((item, index) => {
      const left =
        itemWidth * index +
        pl +
        ((width - itemWidth * isNotMissingData.length) /
          (isNotMissingData.length - 1)) *
          index

      return {
        ...item,
        point: [left, 0, toothPosMap[index], 60, toothPosMap[index], 110],
      }
    })

    return posData
  }, [toothIPRData.iprURToothDataMemo, toothIPRData.iprULToothDataMemo])

  return (
    <div className="my-up-polyline">
      {getUpList.length > 0 &&
        getUpList.map((item, index) => {
          return (
            <div key={index} className="item-polyline">
              <Polyline point={item.point} />
            </div>
          )
        })}
    </div>
  )
}

export default MyUpPolyline
